import {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useCallback,
} from "react";
import { useSearchParams } from "react-router-dom";
import useFetch from "../../../../utils/useFetch";
import CollectionsTemplate from "../../../../components/CollectionsTemplate/index";

import UsersListitems from "./UsersListitem";
import UsersCollectionControls from "./UsersCollectionControls";
import EmptyComponent from "../../../../utils/EmptyComponent";
import UserFilters from "./UserFilters";
import { UsersContext } from "../../../../store/users-context";
import { isArray } from "lodash";
const pageSize = 12;
const queryUrl = "/SystemUser/GetSysUserOrganizations";

const defaultSelections = {
  clientIds: [],
  superClientIds: [],
  adminIds: [],
  venderName: {},
  userStatusActive: false,
  userStatusInactive: false,
};

function userDataAdaptor(data) {
  return {
    headers: [
      { id: "userName", text: "Name", width: "30%" },
      { id: "status", text: "Status", width: "20%" },
      { id: "emailAddress", text: "Email Address (User Name)", width: "20%" },
      { id: "assignedRoles", text: "Assigned Roles", width: "20%" },
      { id: "lastLoginDate", text: "Last Login Date", width: "20%" },
      { id: "icon", width: "2%" },
      { id: "icons", width: "5%" },
    ],
    isEditable: {
      callback: (item) => {
        console.log(item);
      },
      isVisible: true,
    },
    isDeletable: {
      callback: (item) => {
        console.log(item);
      },
      isVisible: true,
    },
    rows: data?.data?.map((d) =>
      Object.assign({}, d, {
        key: d.userId,
      })
    ),
    statusRoleMap: {
      Active: {
        role: "success",
      },
      InActive: {
        role: "error",
      },
    },
  };
}

function toQueryString(obj) {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
}

function getUrl(url, data) {
  return `${url}${toQueryString(data)}`;
}

export default function UserList(props) {
  const { resetUsers, setResetUsers, deleteUser, lastSavedSelections,setFilterSelections } =
    useContext(UsersContext);

  const [allClients, setAllClients] = useState([]);
  const [urlParams, setUrlParams] = useSearchParams();
  const [clientId, setClientId] = useState(
    urlParams.get("clientId") || allClients?.[0]?.id
  );
  const [viewType, setViewType] = useState("list");
  const [filterObj, setFilterObj] = useState(lastSavedSelections);
  const [pageCount, setPageCount] = useState(1);
  const [collection, setCollection] = useState({});
  const [pageNumber, setPageNumber] = useState(1);

  const [paramsState, setParamsState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userStatusActive: false,
    userStatusInactive: false,
    superClientIds: [],
    clientIds: [],
    vendorIds: [],
    adminIds: [],
    isDownloadRequest: false,
    pageSize: 12,
    pageNumber: 1,
  });
  const [url, setUrl] = useState(
    getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj })
  );
  const { data: collectionData, loading, error } = useFetch(url);

  useLayoutEffect(() => {
    if(isNaN(paramsState.pageNumber) || +paramsState.pageNumber < 1){
      setParamsState({...paramsState,pageNumber :1})
    }
    else{
      setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }));
    } 
  }, [paramsState]);

  useLayoutEffect(() => {
    if (collectionData) {
      setPageCount(Math.ceil((collectionData.count || pageSize) / pageSize));
      setCollection(
        userDataAdaptor ? userDataAdaptor(collectionData) : collectionData
      );
    }
  }, [collectionData]);

  const filterChangeHandler = (obj) => {
    setParamsState({
      ...paramsState,
      pageNumber: 1,
      firstName:"",
      lastName: "",
      email: "",
    });

    setFilterObj(obj);
    // setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }));
  };
  useLayoutEffect(() => {
    setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }));
  }, [filterObj]);
  function toggleViewType() {
    setViewType(viewType === "list" ? "grid" : "list");
  }

  function setSearchStr(str) {
    setParamsState({
      ...paramsState,
      firstName: str,
      pageNumber: 1,
    });
    setFilterSelections(defaultSelections);    
    setFilterObj(defaultSelections);

  }
  function setSearchStr2(str) {
    setParamsState({
      ...paramsState,
      lastName: str,
      pageNumber: 1,
    });
    setFilterSelections(defaultSelections); 
    setFilterObj(defaultSelections);

  }
  function setSearchStr3(str) {
    setParamsState({
      ...paramsState,
      email: str,
      pageNumber: 1,
    });
    setFilterSelections(defaultSelections); 
    setFilterObj(defaultSelections);
  }

  const onUserSearchClick = () => {
    setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }));
  };

  useEffect(() => {
    setUrl(
      getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }) +
        "&" +
        resetUsers
    );
  }, [resetUsers]);

  function setPage(pageNumber) {
    setPageNumber(pageNumber);
    setParamsState((prev) => ({ ...prev, pageNumber }));
  }
  return (
    <CollectionsTemplate
      TitlebarChildren={EmptyComponent}
      page={paramsState.pageNumber}
      setPage={setPage}
      pageCount={pageCount}
      fetchState={{ loading, error }}
      collection={collection}
      viewType={viewType}
      responseDataAdaptor={userDataAdaptor}
      ListItemComponent={UsersListitems}
      GridItemComponent={EmptyComponent}
      SlidingPopupTitle="User Filters"
      SlidingPopupContent={
        <UserFilters filterChangeHandler={filterChangeHandler} />
      }
      CollectionControls={(props) => (
        <UsersCollectionControls
          allClients={allClients}
          setClientId={setClientId}
          clientId={paramsState.clientIds}
          setSearchStr={setSearchStr}
          searchStr={paramsState.firstName}
          setSearchStr2={setSearchStr2}
          searchStr2={paramsState.lastName}
          setSearchStr3={setSearchStr3}
          searchStr3={paramsState.email}
          toggleViewType={toggleViewType}
          viewType={viewType}
          searchPlaceholder="Search Users"
          onUserSearchClick={onUserSearchClick}
          downloadUrl={url}
          fileName={"Users"}
          {...props}
        />
      )}
      filterObj={filterObj}
    />
  );
}
